/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2020. All rights reserved
------------------------------------------------------------------------------------------------- */

import { html, LitElement } from 'lit-element';
import { sharedStyles } from '../../styles';
import { windowLocation } from '../../utils/window-location.js';
import breadcrumbItemStyles from './sh-breadcrumb-item.lit.scss.js';
/**
 * @prop {Boolean} active - Defines if the breadcrumb-item is active or not
 * @prop {String} label - The title of the page or context that will be shown in the breadcrumb trail.
 * @prop {String} href - URL of the page or context that the user will be navigated to.
 */

export class SHBreadcrumbItem extends LitElement {
  static get properties() {
    return {
      active: { type: Boolean, reflect: true },
      label: { type: String, reflect: true },
      href: { type: String, reflect: true },
    };
  }

  static get styles() {
    return [sharedStyles, breadcrumbItemStyles];
  }

  render() {
    return html`
      <sh-text title="${this.label}" @click="${() => this._navigateByHref()}"
        >${this.label}</sh-text
      >
      <sh-icon icon="arrow-right-s"></sh-icon>
    `;
  }

  _navigateByHref() {
    if (this.href && !this.active) {
      windowLocation.util.setWindowLocationHRef(this.href);
    }
  }

  connectedCallback() {
    super.connectedCallback();
    if (!this.hasAttribute('role')) {
      this.setAttribute('role', 'link');
    }
  }

  firstUpdated() {
    this.shadowRoot.querySelector('sh-text').setAttribute('tabindex', 0);
    this.addEventListener('focus', () => this._handleFocus());
    this.addEventListener('blur', () => this._handleBlur());
  }

  updated() {
    const breadcrumbText = this.shadowRoot.querySelector('sh-text');
    if (this.active && breadcrumbText) {
      breadcrumbText.removeAttribute('title');
    }
  }

  _handleFocus() {
    this.onkeyup = function (e) {
      const tabKey = 9;
      if (e.keyCode === tabKey) {
        const breadcrumbText = this.shadowRoot.querySelector('sh-text');
        breadcrumbText.classList.add('focus');
      }
    };
  }

  _handleBlur() {
    const breadcrumbText = this.shadowRoot.querySelector('sh-text');
    breadcrumbText.classList.remove('focus');
  }
}

customElements.define('sh-breadcrumb-item', SHBreadcrumbItem);
